import tagIncrementAmountIfExistsInTags from '../tags/tagIncrementAmountIfExistsInTags';
import getMinimumPurchaseTagValue from '../tags/getMinimumPurchaseTagValue';

export const uploadProductData = product => {
  const increaseAmount = tagIncrementAmountIfExistsInTags(
    product.tags,
    'quantidade_aumento:',
  );

  const minimumPurchaseAmount = getMinimumPurchaseTagValue({
    tags: product.tags,
  });

  const isBoxSale = increaseAmount !== 1;
  const shouldCalculateMinimumAmount = isBoxSale && minimumPurchaseAmount !== 1;
  const viewIncreaseAmount = shouldCalculateMinimumAmount
    ? minimumPurchaseAmount / increaseAmount
    : minimumPurchaseAmount;
  const isStatusActive = product.status === 'active';

  return {
    increase_amount: increaseAmount.toString(),
    minimum_purchase_amount: viewIncreaseAmount.toString(),
    discount_percentage: product?.discount_percentage
      ? parseFloat(product.discount_percentage).toString()
      : '',
    full_price: parseFloat(product.full_price).toFixed(2) || '',
    suggested_retail_price: product.suggested_retail_price || '',
    status: isStatusActive,
    variants: product.variants,
    body_html: product.body_html || '',
  };
};
